import * as React from 'react';
import { View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import { GREY_40_10 } from '@/style/colors';
import { Icon } from '@/ui/icon';

type IconBadgeProps = {
  icon: React.ReactNode;
  size?: number;
  iconSize?: number;
};

export function IconBadge({ icon, size = 36, iconSize = 20 }: IconBadgeProps) {
  const { styles, theme } = useStyles(stylesheet);

  return (
    <View style={[styles.container, { width: size, height: size }]}>
      <Icon
        type="naked"
        icon={icon}
        fillColor={theme.colors.icon.color}
        width={iconSize}
        height={iconSize}
      />
    </View>
  );
}

const stylesheet = createStyleSheet(() => ({
  container: {
    borderRadius: 8,
    backgroundColor: GREY_40_10,
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
